// Registration forms and year groups narrow each other; an empty year selection means all ages.
export function participantFormIds(forms: any[], ages: any[] = [], selectedForms: string[] = []): string[] {
  return forms
    .filter(form => !ages.length || ages.map(String).includes(String(form.age)))
    .filter(form => !selectedForms.length || selectedForms.includes(String(form.id)))
    .map(form => String(form.id));
}

export function participantEligibilityWarning(student: any, context: any): string {
  if (!context) return '';
  const warnings: string[] = [];
  const age = student.form && student.form.age;
  if ((context.ages || []).length && (age === undefined || !context.ages.map(String).includes(String(age)))) {
    warnings.push('Outside the configured year groups');
  }
  if (
    (context.gender === 'MALE_ONLY' && student.gender !== 'MALE') ||
    (context.gender === 'FEMALE_ONLY' && student.gender !== 'FEMALE')
  ) {
    warnings.push('Outside the configured gender');
  }
  return warnings.join(' · ');
}

export function participantNameConditions(search: string): any[] {
  return search
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(token => {
      const literal = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return { $or: [{ firstName: { like: literal, options: 'i' } }, { lastName: { like: literal, options: 'i' } }] };
    });
}

// Only staged roster changes are checked locally; the school list is still filtered on the server.
export function matchesClubStudentWhere(student: any, where: any): boolean {
  if (where.formId && !where.formId.$in.map(String).includes(String(student.form && student.form.id))) return false;
  if (where.houseId && !where.houseId.$in.map(String).includes(String(student.house && student.house.id))) return false;
  if (where.gender && where.gender.$in.length && !where.gender.$in.includes(student.gender)) return false;
  if (where.messageStatus && where.messageStatus !== (student.messageStatus || student.clubMessageStatus || 'NOT_SENT'))
    return false;
  if (
    where.messagePriority !== undefined &&
    Number(where.messagePriority) !==
      Number(student.messagePriority !== undefined ? student.messagePriority : student.priority)
  )
    return false;
  return (where.$and || []).every(clause =>
    clause.$or.some(rule => {
      const field = Object.keys(rule)[0];
      return new RegExp(rule[field].like, 'i').test(student[field] || '');
    })
  );
}

// Fetch every matching page, rather than silently truncating a bulk selection at DEFAULT_LIMIT.
export async function allParticipantPages<T>(
  fetchPage: (filter: any) => Promise<T[]>,
  filter: any,
  pageSize = 200
): Promise<T[]> {
  const rows: T[] = [];
  const limit = pageSize;
  for (let skip = 0; ; skip += limit) {
    const page = await fetchPage({ ...filter, limit, skip });
    rows.push(...page);
    if (page.length < limit) return rows;
  }
}
